import { CountBadge } from 'palette/Filters';
import { FilterItem as ItemInterface, OnToggleFilter } from 'palette/Filters/types';
import { ListItem } from 'palette/List';
import { Toggle } from 'palette/Toggle';

interface FilterItemProps {
    item?: ItemInterface;
    onToggleFilter?: OnToggleFilter;
}

export default function FilterItem({
    item,
    onToggleFilter,
}: FilterItemProps) {
    if (!item) return null;

    const {
        name, count, isSelected,
    } = item;

    return (
        <ListItem
            isActive={isSelected}
            rightContent={(<CountBadge count={count} />)}
            onClick={onToggleFilter ? () => onToggleFilter(item) : undefined}
        >
            <Toggle
                id={name}
                isChecked={isSelected}
                label={name}
                variant="checkbox"
            />
        </ListItem>
    );
}
